const SquareIcon = ({ strokeColor = '#808080' }) => (
  <svg
    viewBox="0 0 795.1 795.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>{`
        .cls-1 { fill: #4d4d4d; }
        .cls-2 {
          stroke: ${strokeColor};
          stroke-width: 50px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-3 {
          stroke: #fff;
          stroke-width: 20px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-4 { fill: #fafafa; }
      `}</style>
    </defs>

    <g>
      <circle className="cls-1" cx="397.55" cy="397.55" r="388.66" />
      <circle className="cls-2" cx="397.55" cy="397.55" r="372.55" />
      <circle className="cls-3" cx="397.55" cy="397.55" r="343.4" />
    </g>

    <g>
      <path className="cls-4" d="M396.07,202.22c60.06,0,119.21.02,178.35.03,19.61,0,26.18,6.57,26.15,26.02-.14,107.93-.27,215.85-.39,323.78,0,6.71.22,13.42.11,20.12-.18,11.3-5.91,18.07-16.97,20.06-3.27.59-6.64.9-9.96.9-116.16.04-232.32.05-348.47,0-4.25,0-8.58-.04-12.73-.84-10.73-2.07-17.36-10.21-17.37-21.12-.07-114.33.02-228.66-.28-342.99-.04-15.02,8.01-26.5,25.94-26.26,58.22.8,116.46.29,175.6.29ZM569.22,269.07v-35.06H226.11v327.4h343.1c0-97.44,0-193.98.01-292.34Z" />
    </g>
  </svg>
);

export default SquareIcon;